const SET_PROFILE = "SET_PROFILE";
const CLEAR_STATE = "CLEAR_STATE";
const SET_ROLE = "SET_ROLE";

export { SET_PROFILE, CLEAR_STATE, SET_ROLE};
